import ParametersFormatter from "../../parametersFormatting/ParametersFormatter"
import messageResource from "../../messageResource"
import {DateFormat} from "../../date_format"
import ATReportParamsStringBuilder from '../reportParamsStringBuilder/ATReportParamsStringBuilder'

export default class EVAReportParametersFormatter extends ParametersFormatter {
    init({selectorsData = {}, dateFormat})
    {
        this.reportParamsStringBuilder = new ATReportParamsStringBuilder({
            data: {
                users: selectorsData.users,
                cpList: selectorsData.cpList,
                projectsWithMaIds: selectorsData.projectsWithMaIds,
                statuses: selectorsData.statuses
            },
            dateFormat: dateFormat,
        })
        return this;
    }

    formatTaskSelectionParamsString(tasksConfig, includeNotEstimated, includeNotStarted, dateSelectionWrap)
    {
        const dateSelection = dateSelectionWrap.dateSelection;
        const showOpenTasks = tasksConfig === "ALL" || tasksConfig === "OPEN_ONLY";
        const showCompletedTasks = tasksConfig === "ALL" || tasksConfig === "COMPLETED_ONLY";

        let keyPrefix = '';

        if (showOpenTasks)
        {
            if (showCompletedTasks)
                keyPrefix = "report.budgeted_vs_actual.filter_view.open_and_completed_tasks";
            else
                keyPrefix = "report.budgeted_vs_actual.filter_view.open_tasks";
        }
        else if (showCompletedTasks)
            keyPrefix = "report.budgeted_vs_actual.filter_view.completed_tasks";

        let value = messageResource.getMessage(keyPrefix);

        let addition1 = "",
            addition2 = "",
            separator = "";

        if (!includeNotStarted)
        {
            const date = dateSelectionWrap.isParsed ? dateSelection.date : dateSelection.date.parseJSONDate();
            addition1 = messageResource.getMessage(
                "report.budgeted_vs_actual.filter_view.tasks_started_after",
                [new DateFormat(window.SystemSettings.dateFormat).formatDate(date) + ", " + Date.dayNames[date.getDay()]]
            );
        }

        if (!includeNotEstimated)
        {
            addition2 = messageResource.getMessage("report.budgeted_vs_actual.filter_view.not_budgeted_tasks");
        }

        if (addition1 || addition2)
        {
            if (addition1 && addition2)
                separator = " & ";
            value += " (" + messageResource.getMessage("report.budgeted_vs_actual.filter_view.except")
                     + " " + addition1 + separator + addition2 + ")";
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/ParametersFormatter.js